import _get from 'lodash/get';
import { TaskCompletionFilterInputObject } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import FieldNames from '@lib/enums/fieldNames/taskCompletionsFilterFieldNames';

interface OptionItem {
  value: string;
  label: string;
  [key: string]: unknown;
}

export function createAdditionalFilters(
  filterValues: Values,
): TaskCompletionFilterInputObject[] {
  const filters: TaskCompletionFilterInputObject[] = [];

  const validityHints = _get(
    filterValues,
    FieldNames.ValidityHints,
    [],
  ) as OptionItem[];
  if (validityHints && validityHints.length > 0) {
    filters.push({
      validityHint: {
        predicate: { in: validityHints.map(({ value }) => value) },
      },
    });
  }

  const period = _get(filterValues, FieldNames.Period, []) as string[];
  const [from, to] = period || [];
  if (from) {
    filters.push({ createdAt: { predicate: { gteq: from } } });
  }
  if (to) {
    filters.push({ createdAt: { predicate: { lteq: to } } });
  }

  return filters;
}
